import type { ViewerMeasureApi } from '@mindcloudxai/shared';
import type { ViewerContext } from '../types';

export function createMeasureApi(getCtx: () => ViewerContext): ViewerMeasureApi {
  return {
    isActive: () => isMeasureActive(getCtx()),
    setActive: (active) => setMeasureActive(getCtx(), active),
    toggle: () => toggleMeasure(getCtx()),
    clear: () => clearMeasure(getCtx()),
    setUnitSystem: (system) => setMeasureUnitSystem(getCtx(), system),
  };
}

function isMeasureActive(ctx: ViewerContext): boolean {
  return ctx.viewer?.measureTool?.isActive() ?? false;
}

function setMeasureActive(ctx: ViewerContext, active: boolean): void {
  if (!ctx.global) return;
  if (isMeasureActive(ctx) !== active) {
    ctx.global.events.fire('measure.toggle');
  }
}

function toggleMeasure(ctx: ViewerContext): boolean {
  if (!ctx.global) return false;
  const wasActive = isMeasureActive(ctx);
  ctx.global.events.fire('measure.toggle');
  // measureTool 的 toggle 是同步切换的，返回期望状态比立即再查更可靠
  return !wasActive;
}

function clearMeasure(ctx: ViewerContext): void {
  ctx.global?.events.fire('measure.clear');
}

function setMeasureUnitSystem(ctx: ViewerContext, system: 'metric' | 'imperial'): void {
  ctx.viewer?.measureTool?.setUnitSystem(system);
}
